import IconHint from './IconHint';

export default IconHint;
